import { render, staticRenderFns } from "./ReceivedEmailViewer.vue?vue&type=template&id=6730831c&scoped=true&"
import script from "./ReceivedEmailViewer.vue?vue&type=script&lang=js&"
export * from "./ReceivedEmailViewer.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedEmailViewer.vue?vue&type=style&index=0&id=6730831c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730831c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6730831c')) {
      api.createRecord('6730831c', component.options)
    } else {
      api.reload('6730831c', component.options)
    }
    module.hot.accept("./ReceivedEmailViewer.vue?vue&type=template&id=6730831c&scoped=true&", function () {
      api.rerender('6730831c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/receivedEmails/ReceivedEmailViewer.vue"
export default component.exports